<template>
  <mv-page>
    <mv-default-row>
      <v-layout row wrap>
          <v-flex xs12>
            <v-card flat>
              <v-card-text>
                <v-card-text v-if="success">
                  <h2>Регистрация успешно завершена</h2>
                  <router-link :to="{ name: 'login', params: {} }">Перейти на страницу входа</router-link>
                </v-card-text>
              </v-card-text>
            </v-card>
          </v-flex>
      </v-layout>
    </mv-default-row>
  </mv-page>
</template>

<script>
export default {
  data: () => ({
    success: false,
    destinations: []
  }),
  props: [
    'registrationuid'
  ],
  methods: {
    async fetch() {
      const { destinations } = await this.$store.dispatch('sioRequest', {
        topic: 'destinations',
        pl: {}
      })
      this.destinations = destinations
    },
    async updateDestination (destination) {
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'destinations-update',
          pl: destination
        })
        this.$store.dispatch('snack', meta.msg)
      } catch (err) {
        this.$store.dispatch('snack', err)
        await this.fetch()
      }
    },
    async confirm () {
      if (!this.connected) return null
      if (!this.registrationuid) return null
      try {
        const { meta } = await this.$store.dispatch('sioRequest', {
          topic: 'registrations-create-confirm',
          pl: {
            secret: this.registrationuid
          }
        })
        this.$store.dispatch('snack', meta.msg)
        this.success = true
        await this.fetch()
        // автоматическое подключение email-информирования при прохождении регистрации
        for await (let x of this.destinations) {
          x.subscriptions = ['pass', 'payment', 'lowbalance', 'news', 'purchase']
          await this.updateDestination(x)
          await this.$store.dispatch('sioRequest', {
            topic: 'registrations-create-notification',
            pl: {
              address: x.address
            }
          })
          // await this.$store.dispatch('sioRequest', {
          //   topic: 'emailboxes-create-message',
          //   pl: {
          //     email: x.address
          //   }
          // })
        }
        this.$store.dispatch('logout')
        this.$router.push({ name: 'login' })
      } catch (err) {
        this.$store.dispatch('snack', err)
        if (err.message.includes('Регистрация завершена')) this.success = true
      }
    }
  },
  watch: {
    connected (val) {
      if (val === true) {
        this.confirm()
      }
    }
  },
  computed: {
    connected () {
      return this.$store.state.connected
    }
  },
  mounted () {
    setTimeout(() => { this.confirm() }, 500)
  }
}
</script>
